<script setup lang="ts">
import { AnimationDuration } from "~/shared/enums";

const props = defineProps<{
  element?: keyof HTMLElementTagNameMap;
  duration?: AnimationDuration | number;
}>();

const emit = defineEmits<{
  click: [event: MouseEvent];
  keydown: [event: KeyboardEvent];
  submit: [event: SubmitEvent];
}>();
</script>

<template>
  <component
    :is="element ?? 'div'"
    v-auto-animate="{ duration: props.duration ?? AnimationDuration.SHORT }"
    @click="emit('click', $event)"
    @keydown="emit('keydown', $event)"
    @submit="emit('submit', $event)">
    <slot />
  </component>
</template>
